module.exports = __webpack_public_path__ + "static/media/Pic 5.b2051a90.jpeg";